<template>
  <BaseContainer class="overflow-hidden">
    <!-- Header -->
    <header class="flex items-center justify-between mb-6">
      <h1
        :class="
          twJoin(
            'md:text-5xl !leading-[62px]',
            recommendation && !style && '!text-[32px]',
            style && '!md:text-5xl font-bold md:font-normal',
            style ? 'text-2xl' : 'text-[32px]'
          )
        "
      >
        {{ title }}
      </h1>

      <section v-if="index == 1 || index === 2" class="flex gap-x-2">
        <div
          :class="
            twJoin(
              props.slideKey +
                '-c-button-prev w-8 h-8 flex items-center justify-center rounded bg-black text-white cursor-pointer'
            )
          "
        >
          <Icon name="arrow-left" />
        </div>
        <div
          :class="
            twJoin(
              props.slideKey +
                '-c-button-next w-8 h-8 flex items-center justify-center rounded bg-black text-white cursor-pointer'
            )
          "
        >
          <Icon name="arrow-right" />
        </div>
      </section>
    </header>

    <!-- Content -->
    <template v-if="isLoading">
      <nuxt-error-boundary @error="() => {}">
        <Swiper
          :modules="[SwiperEffectCreative, SwiperNavigation]"
          :slides-per-view="width < 768 ? 2 : 'auto'"
          :space-between="recommendation ? 24 : 16"
          :navigation="{
            enabled: true,
            disabledClass: '!bg-gray-10 !text-typo-disabled',
            nextEl: `.${props.slideKey}-c-button-next`,
            prevEl: `.${props.slideKey}-c-button-prev`
          }"
          :creative-effect="{
            prev: {
              shadow: false,
              translate: ['-20%', 0, -1]
            },
            next: {
              translate: ['100%', 0, 0]
            }
          }"
          class="!overflow-visible md:!overflow-clip"
        >
          <SwiperSlide
            v-for="(item, index) in new Array(4).fill(0)"
            :key="index"
            :class="
              twJoin(
                'min-w-[230px] max-w-[240px] md:max-w-[282px]',
                recommendation &&
                  '!max-w-[unset] md:!max-w-[277px] !min-w-[unset] md:!min-w-[230px]'
              )
            "
          >
            <ProductItemThumbnailSkeleton :key="index" product-listing />
          </SwiperSlide>
        </Swiper>
      </nuxt-error-boundary>
    </template>
    <template v-else-if="index == 1 || index === 2">
      <nuxt-error-boundary @error="() => {}">
        <Swiper
          :modules="[SwiperEffectCreative, SwiperNavigation]"
          :slides-per-view="width < 768 ? 2 : 'auto'"
          :space-between="recommendation ? 24 : 16"
          :navigation="{
            enabled: true,
            disabledClass: '!bg-gray-10 !text-typo-disabled',
            nextEl: `.${props.slideKey}-c-button-next`,
            prevEl: `.${props.slideKey}-c-button-prev`
          }"
          :creative-effect="{
            prev: {
              shadow: false,
              translate: ['-20%', 0, -1]
            },
            next: {
              translate: ['100%', 0, 0]
            }
          }"
          class="!overflow-visible md:!overflow-clip"
        >
          <SwiperSlide
            v-for="(item, index) in data"
            :key="index"
            :class="
              twJoin(
                'min-w-[230px] max-w-[240px] md:max-w-[282px]',
                recommendation &&
                  '!max-w-[unset] md:!max-w-[277px] !min-w-[unset] md:!min-w-[230px]'
              )
            "
          >
            <NuxtLinkLocale
              class="w-full hover:cursor hover:opacity-50"
              :to="item.href"
            >
              <div class="relative w-full pt-[100%]">
                <div
                  class="absolute top-0 left-0 w-full h-full bg-primary-white rounded-xl"
                >
                  <img
                    :alt="item.headerEn ?? item.headerTh ?? 'sticker thumbnail'"
                    :src="item.imageUrl"
                    class="w-full h-full object-cover border-border-divider rounded-xl"
                  />
                  <!-- <div
                class="absolute w-6 h-6 right-0 bottom-[48px] rounded-full border-b border-border-divider -rotate-45 border-l border-l-transparent border-r border-r-transparent"
              />
              <div
                class="absolute w-6 h-6 right-[48px] bottom-0 rounded-full border-b border-border-divider -rotate-45 border-l border-l-transparent border-r border-r-transparent"
              /> -->
                  <div
                    :class="
                      twJoin(
                        'absolute bottom-0 right-0 z-10 pt-2 pl-2 bg-primary-white rounded-tl-lg',
                        // 'border-t border-l border-border-divider',
                        `after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-3 after:h-3 after:bg-[radial-gradient(circle_at_100%_100%,_transparent_12px,_white_12px)] after:rotate-180 after:-translate-x-[100%]`,
                        `before:content-[''] before:absolute before:right-0 before:top-0 before:w-3 before:h-3 before:bg-[radial-gradient(circle_at_100%_100%,_transparent_12px,_white_12px)] before:rotate-180 before:-translate-y-[100%]`
                      )
                    "
                  >
                    <div
                      class="w-16 h-16 bg-[#FCF9A6] hidden md:flex items-center justify-center rounded-xl"
                    >
                      <!-- TODO: create icon file -->
                      <svg
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M25.5 2.01562V19.5156C25.5 20.2188 24.875 20.7656 24.25 20.7656C23.5469 20.7656 23 20.2188 23 19.5156V5.0625L2.60938 25.4531C2.375 25.6875 2.0625 25.7656 1.75 25.7656C1.35938 25.7656 1.04688 25.6875 0.8125 25.4531C0.34375 24.9844 0.34375 24.125 0.8125 23.6562L21.2031 3.26562H6.67188C6.04688 3.26562 5.42188 2.64062 5.5 2.01562C5.5 1.3125 6.04688 0.765625 6.75 0.765625H24.25C24.875 0.765625 25.5 1.39062 25.5 2.01562Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                    <div
                      class="w-10 h-10 bg-primary-tangerine md:hidden flex items-center justify-center rounded-lg"
                    >
                      <!-- TODO: create icon file -->
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M21 1.25V15.25C21 15.8125 20.5 16.25 20 16.25C19.4375 16.25 19 15.8125 19 15.25V3.6875L2.6875 20C2.5 20.1875 2.25 20.25 2 20.25C1.6875 20.25 1.4375 20.1875 1.25 20C0.875 19.625 0.875 18.9375 1.25 18.5625L17.5625 2.25H5.9375C5.4375 2.25 4.9375 1.75 5 1.25C5 0.6875 5.4375 0.25 6 0.25H20C20.5 0.25 21 0.75 21 1.25Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="bg-primary-white relative z-10 pt-4 text-base md:text-xl font-bold"
              >
                {{
                  locale === 'en' ? item.titleEn : item.titleTh || item.titleEn
                }}
              </div>
            </NuxtLinkLocale>
          </SwiperSlide>
        </Swiper>
      </nuxt-error-boundary>
    </template>
    <template v-else>
      <div class="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
        <div v-for="(item, num) in data" :key="num" class="">
          <NuxtLinkLocale
            class="w-full hover:cursor hover:opacity-50"
            :to="item.href"
          >
            <div class="relative w-full pt-[100%]">
              <div
                class="absolute top-0 left-0 w-full h-full bg-primary-white rounded-xl"
              >
                <img
                  :alt="item.headerEn ?? item.headerTh ?? 'sticker thumbnail'"
                  :src="item.imageUrl"
                  class="w-full h-full object-cover border-border-divider rounded-xl"
                />
                <div
                  v-if="index != 0"
                  :class="
                    twJoin(
                      'absolute bottom-0 right-0 z-10 pt-2 pl-2 bg-primary-white rounded-tl-lg',
                      `after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-3 after:h-3 after:bg-[radial-gradient(circle_at_100%_100%,_transparent_12px,_white_12px)] after:rotate-180 after:-translate-x-[100%]`,
                      `before:content-[''] before:absolute before:right-0 before:top-0 before:w-3 before:h-3 before:bg-[radial-gradient(circle_at_100%_100%,_transparent_12px,_white_12px)] before:rotate-180 before:-translate-y-[100%]`
                    )
                  "
                >
                  <div
                    class="w-16 h-16 hidden md:flex items-center justify-center rounded-xl bg-[#FCF9A6]"
                  >
                    <!-- TODO: create icon file -->
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M25.5 2.01562V19.5156C25.5 20.2188 24.875 20.7656 24.25 20.7656C23.5469 20.7656 23 20.2188 23 19.5156V5.0625L2.60938 25.4531C2.375 25.6875 2.0625 25.7656 1.75 25.7656C1.35938 25.7656 1.04688 25.6875 0.8125 25.4531C0.34375 24.9844 0.34375 24.125 0.8125 23.6562L21.2031 3.26562H6.67188C6.04688 3.26562 5.42188 2.64062 5.5 2.01562C5.5 1.3125 6.04688 0.765625 6.75 0.765625H24.25C24.875 0.765625 25.5 1.39062 25.5 2.01562Z"
                        fill="black"
                      />
                    </svg>
                  </div>
                  <div
                    class="w-10 h-10 bg-primary-tangerine md:hidden flex items-center justify-center rounded-lg"
                  >
                    <!-- TODO: create icon file -->
                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21 1.25V15.25C21 15.8125 20.5 16.25 20 16.25C19.4375 16.25 19 15.8125 19 15.25V3.6875L2.6875 20C2.5 20.1875 2.25 20.25 2 20.25C1.6875 20.25 1.4375 20.1875 1.25 20C0.875 19.625 0.875 18.9375 1.25 18.5625L17.5625 2.25H5.9375C5.4375 2.25 4.9375 1.75 5 1.25C5 0.6875 5.4375 0.25 6 0.25H20C20.5 0.25 21 0.75 21 1.25Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <h1
              class="bg-primary-white relative z-10 pt-4 text-base md:text-xl font-bold"
            >
              {{
                locale === 'en' ? item.titleEn : item.titleTh || item.titleEn
              }}
            </h1>
          </NuxtLinkLocale>
        </div>
      </div>
    </template>
  </BaseContainer>
</template>

<script lang="ts" setup>
import { twJoin } from 'tailwind-merge'
const props = defineProps<{
  slideKey: string
  index: number
  recommendation?: boolean
  style?: boolean
  title: string
  data: {
    headerEn?: string
    headerTh?: string
    imageUrl?: string
    mobileImageUrl?: string
    titleEn: string
    titleTh: string
    descriptionEn: string
    descriptionTh?: string
    href?: string
  }[]
  isLoading?: boolean
}>()
const { width } = useWindowSize()
const { locale } = useI18n()
</script>
